import * as React from 'react';
import { CodeComparison } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Card, Row } from 'antd';
class ChangeRecords extends React.Component {
    constructor() {
        super(...arguments);
        this.renderChangeCard = (record) => {
            const { changeDetail, id } = record.change;
            return (React.createElement(Card, { className: 'change', key: id },
                React.createElement(Row, null, changeDetail && this.renderDetail(changeDetail)),
                this.renderCodeComparison(record.change)));
        };
        this.renderCodeComparison = (change) => {
            const { id, newValue, oldValue } = change;
            if (newValue || oldValue) {
                return (React.createElement(CodeComparison, { key: id, newCode: newValue !== null && newValue !== void 0 ? newValue : COPY_SPECIFIC.NONE_PARENTHETICAL, oldCode: oldValue !== null && oldValue !== void 0 ? oldValue : COPY_SPECIFIC.NONE_PARENTHETICAL }));
            }
            return false;
        };
        this.renderDetail = (changeDetail) => React.createElement("div", { className: 'diff' },
            React.createElement("span", { className: 'label' }, COPY_SPECIFIC.CHANGE_DETAIL),
            React.createElement("span", { className: 'value' }, changeDetail));
    }
    render() {
        const { record } = this.props;
        return React.createElement("div", { className: 'modifications' }, this.renderChangeCard(record));
    }
}
export default ChangeRecords;
